import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import DocumentEditor from "@/pages/DocumentEditor";
import InvoiceView from "@/pages/InvoiceView";
import Quotes from "@/pages/Quotes";
import QuoteView from "@/pages/QuoteView";
import Recurring from "@/pages/Recurring";
import RecurringEditor from "@/pages/RecurringEditor";
import RecurringDetail from "@/pages/RecurringDetail";
import Payslips from "@/pages/Payslips";
import PayslipView from "@/pages/PayslipView";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Products from "@/pages/Products";
import Employees from "@/pages/Employees";
import Payments from "@/pages/Payments";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Billing from "@/pages/Billing";
import PaymentCallback from "@/pages/PaymentCallback";
import WorkReports from "@/pages/WorkReports";
import ReportEditor from "@/pages/ReportEditor";
import ReportView from "@/pages/ReportView";
import Team from "@/pages/Team";
import ApiManagement from "@/pages/ApiManagement";
import Plumbing from "@/pages/Plumbing";
import FieldDashboard from "@/pages/FieldDashboard";
import AcceptInvite from "@/pages/AcceptInvite";
import PublicView from "@/pages/PublicView";
import Onboarding from "@/pages/Onboarding";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors closeButton />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/view/:token" element={<PublicView />} />
            <Route
              path="/field"
              element={
                <ProtectedRoute>
                  <FieldDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <Onboarding />
                </ProtectedRoute>
              }
            />

            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/invoices/new" element={<DocumentEditor type="invoice" />} />
              <Route path="/invoices/:id/edit" element={<DocumentEditor type="invoice" />} />
              <Route path="/invoices/:id" element={<InvoiceView />} />
              <Route path="/quotes" element={<Quotes />} />
              <Route path="/quotes/new" element={<DocumentEditor type="quote" />} />
              <Route path="/quotes/:id/edit" element={<DocumentEditor type="quote" />} />
              <Route path="/quotes/:id" element={<QuoteView />} />
              <Route path="/recurring" element={<Recurring />} />
              <Route path="/recurring/new" element={<RecurringEditor />} />
              <Route path="/recurring/:id/edit" element={<RecurringEditor />} />
              <Route path="/recurring/:id" element={<RecurringDetail />} />
              <Route path="/payslips" element={<Payslips />} />
              <Route path="/payslips/:id" element={<PayslipView />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/:id" element={<CustomerDetail />} />
              <Route path="/products" element={<Products />} />
              <Route path="/employees" element={<Employees />} />
              <Route path="/payments" element={<Payments />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/work-reports" element={<WorkReports />} />
              <Route path="/work-reports/new" element={<ReportEditor />} />
              <Route path="/work-reports/:id/edit" element={<ReportEditor />} />
              <Route path="/work-reports/:id" element={<ReportView />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/team" element={<Team />} />
              <Route path="/plumbing" element={<Plumbing />} />
              <Route path="/settings/api" element={<ApiManagement />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/profile" element={<Profile />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
